import React from 'react';
import Views from './Cards';
import Header from './Header';

const Overview = () => {
  return (
    <>
      <Header />
      <Views />
    </>
  );
};

export default Overview;
